var Theme = Theme || {};

Theme.Alerts = (function ($) {
    var $userAlertSignUpModal;

    return {
        init,
        triggerAlertModalOnRedirect,
        triggerContextualAlertModalOnRedirect
    };

    function init() {
        $userAlertSignUpModal = $('.userAlertSignUpModal');
        _alertLinks();
        _contextualAlertLinks();
        _wireModalCloseEvents();
    }

    function _wireModalCloseEvents() {
        $userAlertSignUpModal.on('click keydown', '.js-close-modal', function (e) {
            if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))) {
                e.preventDefault();
                _closeModal();
            }
        });

        $(document).on('keyup', function (e) {
            if (e.key === 'Escape' && $userAlertSignUpModal.hasClass('open')) {
                _closeModal();
            }
        });
    }

    function _closeModal() {
        $userAlertSignUpModal.attr('aria-hidden', 'true');

        // Clear the focus-trap flag before removing 'open' so the Reveal MutationObserver's
        // release path does not run and overwrite our manual restoration below
        // (same guard client.script.js uses for the generic reveal-modal close path).
        $userAlertSignUpModal.data('focusTrapped', false);
        SCM.Utilities.Reveal.close($userAlertSignUpModal);

        if (Theme.Alerts.signupSuccessful && Theme.Alerts.currentAlertButton) {
            Theme.Alerts.currentAlertButton.text('Registered');
            Theme.Alerts.currentAlertButton.prop('disabled', true);
            Theme.Alerts.currentAlertButton.addClass('registered');
            Theme.Alerts.signupSuccessful = false;
        }

        if (Theme.Alerts.lastActiveElement) {
            Theme.Alerts.lastActiveElement.focus();
            Theme.Alerts.lastActiveElement = null;
        }
    }

    Theme.Alerts.lastActiveElement = null;
    Theme.Alerts.currentAlertButton = null;
    Theme.Alerts.signupSuccessful = false;

    function _openModal() {
        Theme.Alerts.lastActiveElement = document.activeElement;
        $userAlertSignUpModal.attr('aria-hidden', 'false');
        SCM.Utilities.Reveal.open($userAlertSignUpModal);

        // Mark trapped before invoking so the Reveal MutationObserver does not re-trap
        // this modal — re-trapping overwrites the saved trigger element with a focusable
        // inside the modal (same guard client.script.js uses for the generic reveal-modal open path).
        $userAlertSignUpModal.data('focusTrapped', true);
        SCM.Focus.trap($userAlertSignUpModal);
    }

    function _shouldShowRegisteredState($button) {
        return $button.closest('.js-alert-show-registered-state').length > 0;
    }

    function _alertLinks() {
        $('body').on('click', '.userAlert .js-open-alert-modal', function (e) {
            var $userAlert = $(e.currentTarget);

            e.preventDefault();

            // Track the button for updating after successful signup
            Theme.Alerts.currentAlertButton = $userAlert;

            if (SCM.SiteJS.isLoggedIn($userAlert)) {
                if (_isMarketingLink($userAlert)) {
                    _navigateToMarketingUrl($userAlert);
                }
                else {
                    _showSignUpAlertInfo($userAlert);
                }
            } else {
                var returnUrl = SCM.SiteJS.getDefaultReturnUrl();

                if (_isMarketingLink($userAlert)) {
                    returnUrl = _getMarketingUrl($userAlert);
                } else {
                    returnUrl = _triggerAlertSignUpOnReturn($userAlert, returnUrl);
                }

                window.location = `/sign-in?returnUrl=${encodeURIComponent(returnUrl)}`;
            }
        });

        $('body').on('click', '.js-guest-alert-trigger', function (e) {
            var $userAlert = $(e.currentTarget);
            e.preventDefault();
            _showGuestAlertDialog($userAlert);
        });

        // Enter already activates <a href> natively; only Space needs an explicit handler for role="button" links.
        $('body').on('keydown', '.js-open-alert-modal, .js-guest-alert-trigger', function (e) {
            if (e.key === ' ') {
                e.preventDefault();
                $(e.currentTarget).trigger('click');
            }
        });

        $('body').on('submit', '.js-alert-signup-form', function (e) {
            e.preventDefault();

            var $form = $(this);
            var $button = $form.find('.js-btn-alert-signup');
            var originalText = $button.text();

            $form.find('.error').hide();

            if (!$form[0].checkValidity()) {
                $form.find('.error').show();
                return;
            }

            var captchaResponse = SCM.Captcha.GetCaptchaResponse($form);
            if (!captchaResponse) {
                $form.find('.error').html('Please complete the captcha verification.').show();
                return;
            }

            $button.prop('disabled', true).html('<span class="spinner"></span> Signing Up...');

            var formData = new FormData($form[0]);
            formData.append('CaptchaResponse', captchaResponse);

            SCM.Ajax.post('/toolbox/AlertSignupModal', formData)
                .expectJson()
                .then(function (result) {
                    if (result.Success) {
                        SCM.Ajax.get('/toolbox/AlertThankYouDialog', { email: result.UserEmail })
                            .expectHtml()
                            .then(function (dialogHtml) {
                                $('.userAlertSignUp').html(dialogHtml);
                                // Mark button as registered (if opt-in class present)
                                if (Theme.Alerts.currentAlertButton && _shouldShowRegisteredState(Theme.Alerts.currentAlertButton)) {
                                    Theme.Alerts.currentAlertButton.text('Registered');
                                    Theme.Alerts.currentAlertButton.prop('disabled', true);
                                    Theme.Alerts.currentAlertButton.addClass('registered');
                                }
                                if (SCM.GoogleTagManagerDataLayerEvents) {
                                    var eissn = Theme.Alerts.currentAlertButton ? Theme.Alerts.currentAlertButton.data('eissn') || '' : '';
                                    SCM.GoogleTagManagerDataLayerEvents.logJournalAlertSubscribe('modal', eissn);
                                }
                            });
                    } else {
                        $button.prop('disabled', false).html(originalText);
                        $form.find('.error').html(result.ErrorMessage).show();
                        SCM.Captcha.ResetCaptcha($form);
                    }
                })
                .catch(function (error) {
                    $button.prop('disabled', false).html(originalText);
                    console.error('Alert signup failed:', error);
                    SCM.Captcha.ResetCaptcha($form);
                });
        });

        $('body').on('click', '.alert-thankyou-dialog .js-btn-close-thankyou', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $modal = $('.userAlertSignUpModal');
            if ($modal.length) {
                SCM.Utilities.Reveal.close($modal);
            }
        });
    }

    function _showGuestAlertDialog($userAlert) {
        var alertType = $userAlert.data('alertType');
        var alertResourceId = $userAlert.data('alertResourceId');
        var alertResourceType = $userAlert.data('alertResourceType');
        var alertResourceName = $userAlert.data('alertResourceName');
        var siteId = $userAlert.data('siteId');
        var scheduleId = $userAlert.data('scheduleId');

        var ajaxUrl = '/toolbox/AlertSignupModal';
        var ajaxData = {
            alertTypeId: alertType,
            resourceId: alertResourceId,
            resourceType: alertResourceType,
            resourceName: alertResourceName,
            siteId: siteId,
            scheduleId: scheduleId
        };

        SCM.Ajax.get(ajaxUrl, ajaxData)
            .expectHtml()
            .then(function (dialogHtml) {
                $('.userAlertSignUp').html(dialogHtml);
                _openModal();
            })
            .catch(function (error) {
                console.error('Failed to load guest alert dialog:', error);
                window.location = '/sign-in';
            });
    }

    function _isMarketingLink($userAlert) {
        return $userAlert.parent().hasClass('alertType-MarketingLink');
    }

    function _navigateToMarketingUrl($userAlert) {
        window.location = _getMarketingUrl($userAlert);
    }

    function _getMarketingUrl($userAlert) {
        return $userAlert.data('additionalUrl');
    }

    function _triggerAlertSignUpOnReturn($userAlert, returnUrl) {
        var alertType = $userAlert.data('alertType');
        if (alertType) {
            returnUrl = `${returnUrl}#triggerAlertType=${alertType}`;
        }
        return returnUrl;
    }

    function _contextualAlertLinks() {
        $('body').on('click', '.js-contextual-alert-signup', function () {
            if (SCM.SiteJS.isLoggedIn()) {
                var subdomain = App.CurrentSubdomain;
                var ajaxUrl = `/${subdomain}/my-account/contextual-alerts-modal/MyContextualAlerts`;
                SCM.Ajax.get(ajaxUrl)
                    .expectHtml()
                    .then(function (result) {
                        SCM.Modals.showModal(result);
                        App.MyAlerts.Init();
                    });
            }
            else {
                var returnUrl = SCM.SiteJS.getDefaultReturnUrl();
                returnUrl = _triggercontextualAlertSignUpOnReturn(returnUrl);
                window.location = `/sign-in?returnUrl=${encodeURIComponent(returnUrl)}`;
            }
        });
    }

    function _triggercontextualAlertSignUpOnReturn(returnUrl) {
        returnUrl = `${returnUrl}#triggerContextualAlerts=true`;
        return returnUrl;
    }

    function _showSignUpAlertInfo($userAlert) {
        const AjaxURL = (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/Toolbox/AlertsSignUp/AlertsSignUpPopup';
        const AjaxData = {
            alertType: $userAlert.data('alertType'),
            resourceId: $userAlert.data('alertResourceId'),
            resourceType: $userAlert.data('alertResourceType'),
            email: $userAlert.data('alertUserEmail'),
            resourceName: $userAlert.data('alertResourceName'),
            siteId: $userAlert.data('siteId')
        };

        $('.userAlertSignUp').html('<h3>Loading...</h3>');

        SCM.Ajax.get(AjaxURL, AjaxData)
            .expectHtml()
            .then(_handleAjaxSuccess)
            .catch(console.error);

        function _handleAjaxSuccess(responseHtml) {
            const ShouldBypassAlertConfirmation = $userAlertSignUpModal.data('bypassConfirmation') === 'true';

            if (_alertAlreadyExists(responseHtml) || !ShouldBypassAlertConfirmation) {
                $('.userAlertSignUp').html(responseHtml);
                _openModal();

                $('.addUserAlert').on('click', function () {
                    const HasMultipleSchedules = !!$(this).data('hasmultipleschedules');
                    _executeAlertSignUp($userAlert, HasMultipleSchedules);
                });
            } else {
                _executeAlertSignUp($userAlert, false);
            }
        }
    }

    function _alertAlreadyExists(responseHtml) {
        return !$(responseHtml).filter('.addUserAlert').length;
    }

    function _executeAlertSignUp($userAlert, hasMultipleSchedules) {
        const AlertSignUpData = _buildAlertSignUpData($userAlert, hasMultipleSchedules);
        _addSignUpAlert(AlertSignUpData, hasMultipleSchedules);
    }

    function _buildAlertSignUpData($elem, hasMultipleSchedules) {
        let alertSignUpData = {};
        alertSignUpData.alertType = $elem.data('alertType');
        alertSignUpData.resourceId = $elem.data('alertResourceId');
        alertSignUpData.resourceType = $elem.data('alertResourceType');
        alertSignUpData.email = $elem.data('alertUserEmail');
        alertSignUpData.resourceName = $elem.data('alertResourceName');
        alertSignUpData.siteId = $elem.data('siteId');

        if ($elem.data('scheduleId')) {
            alertSignUpData.scheduleId = $elem.data('scheduleId');
        }

        if (hasMultipleSchedules) {
            alertSignUpData.scheduleId = $('.js-new-useralert-select').val();
        }
        return alertSignUpData;
    }

    function _addSignUpAlert(alertSignUpData, hasMultipleSchedules) {
        const ActionUrl = _getActionURL(hasMultipleSchedules, alertSignUpData);
        const AjaxUrl = (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + ActionUrl;

        SCM.Ajax.get(AjaxUrl, alertSignUpData)
            .expectHtml()
            .then(_handleAjaxSuccess)
            .catch(console.error);

        function _handleAjaxSuccess(data) {
            $('.userAlertSignUp').html(data);
            _openModal();
            if (SCM.GoogleTagManagerDataLayerEvents) {
                var eissn = Theme.Alerts.currentAlertButton ? Theme.Alerts.currentAlertButton.data('eissn') || '' : '';
                SCM.GoogleTagManagerDataLayerEvents.logJournalAlertSubscribe('sidebar', eissn);
            }
            // Flag signup as successful - button text will update when modal closes
            if (Theme.Alerts.currentAlertButton && _shouldShowRegisteredState(Theme.Alerts.currentAlertButton)) {
                Theme.Alerts.signupSuccessful = true;
            }
        }
    }

    function _getActionURL(hasMultipleSchedules, alertSignUpData) {
        const SyncOnlyAlertTypeId = 27;
        let method;
        if (!!alertSignUpData.alertType && alertSignUpData.alertType === SyncOnlyAlertTypeId) {
            method = 'AddAlertsSignUpWithoutResource';
        } else if (hasMultipleSchedules || !!alertSignUpData.scheduleId) {
            method = 'AddAlertsSignUpWithSchedule';
        } else {
            method = 'AddAlertsSignUp';
        }

        return `/Toolbox/${method}/AddAlertsSignUpPopup`;
    }

    function triggerAlertModalOnRedirect() {
        var alertType = SCM.JSUtility.getParamFromHash('triggerAlertType');
        if (alertType) {
            $(`.userAlert a[data-user-logged-in="True"][data-alert-type="${alertType}"]`).trigger('click');
            SCM.JSUtility.removeParamFromHash('triggerAlertType');
        }
    }

    function triggerContextualAlertModalOnRedirect() {
        let triggerContextualAlerts = SCM.JSUtility.getParamFromHash('triggerContextualAlerts');
        if (triggerContextualAlerts) {
            $('.js-contextual-alert-signup').trigger('click');
            SCM.JSUtility.removeParamFromHash('triggerContextualAlerts');
        }
    }

})(jQuery);

// If we are in a module context, export this module
'object' === typeof module && module.exports && (module.exports = Theme.Alerts);